/*
 * @Author: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @Date: 2026-01-09 16:41:35
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2026-01-09 16:50:04
 */
import { useState, useCallback, useEffect } from 'react'
import { DEFAULT_FOLDER_LEVELS } from '../constants'

interface FolderLevel {
  level: number
  field: string | undefined
}

export const useFolderState = (
  initialLevels: FolderLevel[] = DEFAULT_FOLDER_LEVELS
) => {
  const [folderLevels, setFolderLevels] = useState<FolderLevel[]>(initialLevels)

  // 支持动态更新初始值
  useEffect(() => {
    if (initialLevels && initialLevels !== DEFAULT_FOLDER_LEVELS) {
      setFolderLevels(initialLevels)
    }
  }, [initialLevels])

  const handleLevelChange = useCallback(
    (level: number, value: string | undefined) => {
      setFolderLevels((prevLevels) => {
        const levels = prevLevels
          ? [...prevLevels]
          : DEFAULT_FOLDER_LEVELS.slice()
        const idx = level - 1
        levels[idx] = { ...levels[idx], field: value }

        // 如果上级被清空（或设为默认 ''），将下级重置为"未选择"（undefined）
        if (value === '' || value === undefined || value === null) {
          for (let i = idx + 1; i < levels.length; i++) {
            levels[i] = { ...levels[i], field: undefined }
          }
        }

        return levels
      })
    },
    []
  )

  const handleFolderRuleChange = useCallback(
    (folderRule: string, folderTitles: string) => {
      // 为单级调用者提供向后兼容处理
      const levels: FolderLevel[] = [
        { level: 1, field: folderRule },
        { level: 2, field: undefined },
        { level: 3, field: undefined }
      ]
      setFolderLevels(levels)
    },
    []
  )

  return {
    folderLevels,
    setFolderLevels,
    handleLevelChange,
    handleFolderRuleChange
  }
}
